import React, { Component } from "react";
import { connect } from "react-redux";
import {
  CHECKBOX_CHECKED,
  CHECKBOX_UNCHECKED,
  CHECKBOX_INDETERMINATE
} from "Config";
import { onSuccess, onError } from "Utils";
import styles from "./Item.local.scss";
import {
  fetchAssociationDashboard,
  saveAssociationDashboard,
  fetchOrganizations
} from "Thunks";
import {
  setOrganizationSelectedItem,
  setSelectPrincipalDashboard
} from "actions";

import _ from "i18n";
import CheckBox from "./CheckBox";
import { ICONS, SvgIcon } from "../Common/Icons";
import OrganizationDashboardFetching from "./OrganizationDashboardFetching";
import { ModalConfirm } from "tamtam-components";
import classnames from "classnames";
import OrganizationFilterFetching from "./OrganizationFilterFetching";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import stylesButton from "../Common/Modal/Button.local.scss";
import { getLabelsByLng } from "../../utils";

class OrganizationActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAssociationModal: false,
      dashboardId: null,
      disabled: true,
      isOpenModal: false
    };
  }

  handleSelectAllClient = () => {
    let { selectedClients, organizationsList } = this.props;
    if (selectedClients.length === organizationsList.length) {
      selectedClients = [];
    } else {
      selectedClients = organizationsList.map(organization => organization.id);
    }
    this.props.dispatch(setOrganizationSelectedItem(selectedClients));
  };

  showAssociationModal = () => {
    this.setState({
      showAssociationModal: true,
      dashboardId: null,
      disabled: true
    });
    this.props.dispatch(fetchAssociationDashboard());
  };

  handleSubmitAssociationModal = () => {
    const { dashboardId, disabled } = this.state;
    if (disabled) {
      return;
    }

    this.setState({ loading: true });

    this.props.dispatch(saveAssociationDashboard({ dashboardId })).then(
      res => {
        this.setState({ loading: false, showAssociationModal: false });
        onSuccess(res, {
          body: _("updateAssociationSuccess"),
          title: _("saveSuccess")
        });
        this.props.dispatch(fetchOrganizations(this.props.synchro));
      },
      err => {
        this.setState({ loading: false, showAssociationModal: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleCancelAssociationModal = () => {
    const { disabled } = this.state;
    if (!disabled) {
      this.setState({ isOpenModal: true });
    } else {
      this.setState({ showAssociationModal: false });
    }
  };

  handleSelectPrincipalDashboard = dashboardId => {
    const { associationDashboard } = this.props;
    this.setState({ dashboardId: dashboardId, disabled: false });

    let newAssociationDashboard = [...associationDashboard];

    let newSelection = newAssociationDashboard.map(element => {
      if (element.id === dashboardId) {
        if (element.state !== CHECKBOX_CHECKED) {
          element.state = CHECKBOX_CHECKED;
        } else {
          this.setState({ dashboardId: null });
          element.state = CHECKBOX_UNCHECKED;
        }
      } else {
        element.state = CHECKBOX_UNCHECKED;
      }
      return element;
    });
    this.props.dispatch(setSelectPrincipalDashboard(newSelection));
  };
  renderModalFooterAssociateDashboard = () => {
    return [
      <button
        key="back"
        className={stylesButton.back}
        onClick={this.handleCancelAssociationModal}
      >
        {_("cancel")}
      </button>,
      <button
        key="submit"
        type="primary"
        className={stylesButton.save}
        onClick={this.handleSubmitAssociationModal}
        disabled={this.state.disabled}
      >
        {this.state.loading && (
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("save")}
      </button>
    ];
  };

  render() {
    let {
      fetched,
      fetching,
      organizationsList,
      selectedClients,
      associationDashboard,
      fetchingCLientList,
      lng,
      statusCounts
    } = this.props;
    const presentationStatus = [
      { label: _("all"), value: "" },
      { label: _("notPrepared"), value: "NOT_PREPARED" },
      { label: _("prepared"), value: "PREPARED" },
      { label: _("presented"), value: "PRESENTED" }
    ];
    const { isOpenModal } = this.state;

    // const { loggedAs, preferences } = auth;

    let allowAssociateDashboards = true;
    /* loggedAs === "MANAGER" ||
      (preferences && preferences.allowAssociateDashboards === "1");*/
    if (fetchingCLientList || this.props.cardsFetching) {
      return <OrganizationFilterFetching />;
    }
    return (
      <div className={styles.actions}>
        {organizationsList.length > 0 &&
          selectedClients.length > 0 && (
            <div
              className={`${styles.select_all} ${
                selectedClients.length > 0 ? styles.select_all_active : ""
              }`}
              onClick={this.handleSelectAllClient}
            >
              <CheckBox
                state={
                  selectedClients.length === organizationsList.length
                    ? CHECKBOX_CHECKED
                    : selectedClients.length > 0
                      ? CHECKBOX_INDETERMINATE
                      : CHECKBOX_UNCHECKED
                }
                handleSelectCheckbox={this.handleSelectAllClient}
              />
              {_("selectAll")}
            </div>
          )}
        {!selectedClients.length > 0 &&
          presentationStatus.map((item, i) => {
            return (
              <div
                className={classnames(
                  styles.presentation_filter_button,
                  item.value == this.props.presentationState
                    ? styles.filterActivated
                    : ""
                )}
                onClick={() => {
                  this.props.presentationStatusChange(item.value);
                }}
              >
                {item.value === "" ? (
                  <p>
                    {item.label} ({statusCounts &&
                      parseInt(statusCounts["NOT_PREPARED"]) +
                        parseInt(statusCounts["PREPARED"]) +
                        parseInt(statusCounts["PRESENTED"])})
                  </p>
                ) : (
                  <p>
                    {item.label} ({statusCounts && statusCounts[item.value]})
                  </p>
                )}
              </div>
            );
          })}
        {allowAssociateDashboards &&
          selectedClients.length > 0 && (
            <div
              className={styles.associate_clients}
              onClick={this.showAssociationModal}
            >
              <SvgIcon
                icon={ICONS.CLIENTS_LIST}
                className={styles.small_action_icon}
              />
              {_("associateClient")}
            </div>
          )}

        <TTPReactModal
          title={_("associateClientTitle")}
          isOpen={this.state.showAssociationModal}
          inProcess={false}
          onConfirm={this.handleOk}
          onCancel={this.handleCancelAssociationModal}
          footer={this.renderModalFooterAssociateDashboard()}
          associateModal={true}
        >
          <ModalConfirm
            type={"return"}
            isOpen={isOpenModal}
            onCancel={() => this.setState({ isOpenModal: false })}
            onConfirm={() => {
              this.setState({ showAssociationModal: false });
              this.setState({ isOpenModal: false });
            }}
            inProcess={false}
            actionFailed={false}
            title={_("cancelConfirm")}
            text={_("cancelConfirmContent")}
            labelNo={_("cancel")}
            labelYes={_("exit")}
            labelError={"Error"}
          />
          <div>
            <div
              className={classnames(
                styles.description,
                styles.title_client_list
              )}
            >
              {_("clientsList")}:
            </div>
            <div className={styles.div_elements}>
              {selectedClients.map((id, i) => {
                return (
                  <div
                    key={i}
                    className={classnames(styles.element, styles.client)}
                  >
                    {
                      organizationsList.filter(
                        organisation => organisation.id === id
                      )[0].organization.name
                    }
                  </div>
                );
              })}
            </div>
            <div className={styles.description}>{_("dashboardPrincipal")}:</div>
            <div
              className={classnames(
                styles.div_elements,
                styles.dashboard_principal
              )}
            >
              {fetching && <OrganizationDashboardFetching />}
              {fetched &&
                associationDashboard.map((dashboard, i) => {
                  return (
                    <div
                      key={i}
                      className={styles.element + " " + styles.element_dasboard}
                    >
                      <CheckBox
                        state={dashboard.state}
                        handleSelectCheckbox={() =>
                          this.handleSelectPrincipalDashboard(dashboard.id)
                        }
                      />
                      <span
                        className={
                          dashboard.name.length > 25 && styles.dashbord_name
                        }
                      >
                        {getLabelsByLng(JSON.parse(dashboard.name), lng)}
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
        </TTPReactModal>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth,
  fetching: state.organizations.associationDashboard.fetching,
  fetchingCLientList: state.organizations.list.fetching,
  fetched: state.organizations.associationDashboard.fetched,
  associationDashboard: state.organizations.associationDashboard.data,
  selectedClients: state.organizations.list.selected,
  organizationsList: state.organizations.list.items,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  statusCounts: state.organizations.list.statusCounts,
  lng: state.params.lng
});

export default connect(mapStateToProps)(OrganizationActions);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationActions.js